
import LoadingAnimation from "../../componets/loader/loader";
import { API } from "../../config/api";
import { GET, POST } from "../../utils/apicalls";
import {
  Button,
  Card,
  Form,
  Input,
  Modal,
  notification,
  Space,
  Table,

} from "antd";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function ContactInformation() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [aboutdata, setAboutData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const fetchAboutus = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.LIST_CONTACT_INFORMATION, {});
      setAboutData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAboutus();
  }, []);

  // Handle form submission
  const submitHandler = async (values: any) => {
    try {
      let obj = {
        contactNumber: values.contactNumber,
        customer_care_number: values.customer_care_number,
        faceBookLink: values.faceBookLink,
        instaLink: values.instaLink,
        youtubeLink: values.youtubeLink,
        email: values.email,
        address: values.address,
        Whatsapp: values.Whatsapp,
      };

      setIsLoading(true);
      const postRequest: any = await POST(API.CREATE_CONTACT_INFORMATION, obj);
      if (postRequest.status) {
        notification.success({
          message: "contact information added successfully!",
        });

        form.resetFields();

        fetchAboutus();
        setIsModalOpen(false); // Close modal
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => index + 1,
    },
    { title: "contactNumber", dataIndex: "contactNumber" },
    { title: "customer_care_number", dataIndex: "customer_care_number" },
    {
      title: "instaLink",
      dataIndex: "instaLink",
    },
    { title: "faceBookLink", dataIndex: "faceBookLink" },
    { title: "youtubeLink", dataIndex: "youtubeLink" },
    { title: "email", dataIndex: "email" },
    { title: "address", dataIndex: "address" },
    { title: "Whatsapp", dataIndex: "Whatsapp" },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space size="middle">
          {/* <Button type="link"  onClick={() => confirmDelete(record.id)}>Delete</Button> */}
          <Button
            type="link"
            onClick={() =>
              navigate(
                `/Admin/adminContactInformation/updatecontactinformation/${record.id}`
              )
            }
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div className="banner-container">
        {isLoading ? (
          <LoadingAnimation />
        ) : (
          <div className="banner-content">
            <h1 className="banner-title">Contact Information Details </h1>
            {aboutdata.length === 0 && (
              <button
                className="banner-button"
                onClick={() => setIsModalOpen(true)}
              >
                Create Contact Information
              </button>
            )}
          </div>
        )}
      </div>

      <div className="w-full px-4">
        <Card className="w-full">
          {isLoading ? (
            <LoadingAnimation />
          ) : (
            <div className="overflow-x-auto">
              <Table
                columns={columns}
                dataSource={aboutdata}
                loading={isLoading}
                pagination={{ pageSize: 5 }}
                scroll={{ x: "max-content" }}
              />
            </div>
          )}
        </Card>
      </div>

      <Modal
        title="Add Contact Information"
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="90%"
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Form.Item
            name="contactNumber"
            label="contactNumber"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="customer_care_number"
            label="customer_care_number"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="faceBookLink"
            label="faceBookLink"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="instaLink"
            label="instaLink"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="youtubeLink"
            label="youtubeLink"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="email" label="email" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item
            name="address"
            label="address"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="Whatsapp"
            label="Whatsapp"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
}

export default ContactInformation;
